export default __webpack_public_path__ + "static/media/discover.a8d2fdc3.jpg";